<template><section><!-- ---
title: Webpack系列之基本概念
date: 2022-11-01
tags: Webpack系列
set: WebpackBase
--- -->
<p>Webpack是一种前端资源构建工具，一个静态模块打包器，在webpack看来，前端的所有资源文件(<code v-pre>js</code>/<code v-pre>json</code>/<code v-pre>css</code>/<code v-pre>img</code>/<code v-pre>less</code>...)都会作为模块处理。它将根据模块的依赖关系进行静态分析，打包生成对应的静态资源。</p>
<h4>1. webpack五个核心概念</h4>
<ul>
<li><strong>Entry</strong>：指示<code v-pre>webpack</code>以哪个文件为入口起点开始打包，分析构建内部依赖图</li>
<li><strong>Output</strong>：指示<code v-pre>webpack</code>打包后的资源<code v-pre>bundles</code>输出到哪里，以及如何命名</li>
<li><strong>Loader</strong>：<code v-pre>webpack</code>只能理解<code v-pre>Javascript</code>和<code v-pre>Json</code>文件，这是<code v-pre>webpack</code>开箱可用的自带能力，<code v-pre>loader</code>让<code v-pre>webpack</code>能够去处理其他类型的文件，并将它们转换为有效模块，以供应用程序使用，以及被添加到依赖图中</li>
<li><strong>Plugins</strong>：可以用于执行范围更广的任务。插件的范围包括，从打包优化和压缩，一直到重新定义环境中的变量等。</li>
<li><strong>Mode</strong>：指定<code v-pre>webpack</code>使用相应模式的配置
<ul>
<li><strong>development</strong>：能让代码本地调试的开发环境</li>
<li><strong>production</strong>：能让代码优化上线运行的生产环境，生产环境比开发环境多一个压缩<code v-pre>js</code>代码</li>
</ul>
</li>
</ul>
<h4>2. webpack配置文件</h4>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> { resolve } = <span class="hljs-built_in">require</span>(<span class="hljs-string">'path'</span>)

<span class="hljs-built_in">module</span>.exports = {
    <span class="hljs-attr">entry</span>: <span class="hljs-string">'./src/index.js'</span>, 
    <span class="hljs-attr">output</span>: {
        <span class="hljs-attr">filename</span>: <span class="hljs-string">'build.js'</span>,
        <span class="hljs-attr">path</span>: resolve(__dirname, <span class="hljs-string">'build'</span>)
    },
    <span class="hljs-attr">module</span>: {
        <span class="hljs-attr">rules</span>: [
            {
                <span class="hljs-attr">test</span>: <span class="hljs-regexp">/\.css$/</span>,
                <span class="hljs-attr">use</span>: [
                    <span class="hljs-string">'style-loader'</span>,
                    <span class="hljs-string">'css-loader'</span>
                ]
            },
            {
                <span class="hljs-attr">test</span>: <span class="hljs-regexp">/\.less$/</span>,
                <span class="hljs-attr">use</span>: [
                    <span class="hljs-string">'style-loader'</span>,
                    <span class="hljs-string">'css-loader'</span>,
                    <span class="hljs-string">'less-loader'</span>
                ]
            }
        ]
    },
    <span class="hljs-attr">plugins</span>: [],
    <span class="hljs-attr">module</span>: <span class="hljs-string">'development'</span>
}
</code></pre>
<p>需要特别注意的是<code v-pre>loader</code>的执行顺序，<code v-pre>loader</code>的执行是从右到左，从下到上的，例如解析<code v-pre>less</code>文件，要先<code v-pre>less-loader</code>、<code v-pre>css-loader</code>到<code v-pre>style-loader</code></p>
</section></template>

